<footer>
    <div class="container-footer-all">
        <div class="container-body">
            <div class="colum4">
                <img src="assets/img/logo3.png">
            </div>
            <hr>
            <div class="colum1">
                <h1>"Nuestra prioridad es ayudar al crecimiento de los negocios 
                    interconectando oportunidades entre empresas."</h1>
            </div>
            <div class="colum2">
                <h1>CONTACTANOS</h1>
                <div class="row">
                    <label>Direccion: Transversal 15#103a-80 Torre 6 Apto 101 – Bucaramanga</label>
                </div>
                <div class="row">
                    <label>Telefono: (+57) 313 320 7248</label>
                </div>
                <div class="row">
                    <label>Email: info@ingherrera.com</label>
                </div>
            </div>
        </div>

    </div>
    <div class="container-footer">
        <div class="footerCopy">
            <div class="copyright">
                © {{year| date:'yyyy'}} Todos los derechos reservados | <a href="">
          INGHERRERA</a>
            </div>
        </div>
    </div>
</footer>